/**
 * CSV Exporter with UTF-8 BOM support for Microsoft Excel & LibreOffice compatibility.
 * Accents and special characters are preserved properly without encoding artifacts.
 */
import { ElMessage } from 'element-plus'

/**
 * Escapes a cell value for CSV (RFC 4180).
 */
function escapeCsvCell(val) {
  if (val === null || val === undefined) return '""'
  const str = String(val).trim()
  if (/[",\n\r;]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`
  }
  return `"${str}"`
}

/**
 * Exports data rows to a CSV file and triggers a browser download.
 *
 * @param {string} filename - Target filename (e.g. "missions_export.csv")
 * @param {Array<{ key: string, label: string, format?: (val: any, row: any) => string }>} columns - Column definitions
 * @param {Array<Object>} rows - Array of records
 */
export function exportToCsv(filename, columns, rows) {
  if (!rows || rows.length === 0) {
    ElMessage.warning('Aucune donnée à exporter.')
    return
  }

  const headerRow = columns.map(c => escapeCsvCell(c.label)).join(';')
  const dataRows = rows.map(row => {
    return columns.map(c => {
      const rawVal = row[c.key]
      const formattedVal = typeof c.format === 'function' ? c.format(rawVal, row) : rawVal
      return escapeCsvCell(formattedVal)
    }).join(';')
  })

  // \uFEFF is the UTF-8 Byte Order Mark (BOM) ensuring Excel displays accents correctly
  const csvContent = '\uFEFF' + [headerRow, ...dataRows].join('\r\n')
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.setAttribute('href', url)
  link.setAttribute('download', filename.endsWith('.csv') ? filename : `${filename}.csv`)
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)

  ElMessage.success(`Export réussi : ${rows.length} ligne(s) téléchargée(s).`)
}
